import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import config from "../../../config";
import PrintHeaderAccount from "../../../Pdf/PrintHeaderAccount";
import PrintFooter from "../../../Pdf/PrintFooter";
import { saleReportStyles } from "../../../Pdf/pdfStyles";
import {
  PrintFormateNumber,
  parseReportAmount,
} from "../../../Pdf/PrintFormateNumber";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
} from "@react-pdf/renderer";
import { Spin } from "antd";
import moment from "moment";

const DETAIL_COL = {
  sr: 26,
  dated: 54,
  product: 80,
  qty: 46,
  salePrice: 52,
  amount: 95,
  buyPrice: 52,
  profit: 82,
};

const SUMMARY_COL = {
  sr: 26,
  product: 120,
  qty: 52,
  salePrice: 60,
  amount: 95,
  buyPrice: 60,
  profit: 154,
};

const SUMMARY_LABEL = 380;
const SUMMARY_VALUE = 187;

const SUMMARY_ROWS = [
  { label: "Total sales", key: "TotalSales" },
  { label: "Profit on sales", key: "ProfitOnSales" },
  { label: "Stock gains", key: "totalGain" },
  { label: "Other income", key: "otherIncome" },
  { label: "Gross profit", key: "GrossProfit", bold: true },
  { label: "—", key: null, separator: true },
  { label: "Total expenses", key: "TotalExpenes" },
  { label: "Total discounts", key: "TotalDiscount" },
  { label: "Total withdrawal", key: "TotalWithDrawal" },
  { label: "Stock losses", key: "totalLoss" },
  { label: "Gross expenses", key: "GrossExpenses", bold: true },
  { label: "—", key: null, separator: true },
  { label: "Net profit", key: "NetProfit", bold: true },
];

function PrintProfitOnSale() {
  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");

  const urlParams = new URLSearchParams(window.location.search);
  const StartDate = urlParams.get("StartDate");
  const EndDate = urlParams.get("EndDate");
  const ProductID = urlParams.get("ProductID") || "0";
  const SupplierID = urlParams.get("SupplierID") || "0";
  const showDetails = urlParams.get("ShowDetails") !== "0";

  const [data, setData] = useState({});
  const [detailRows, setDetailRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Print Profit On Sale";
    if (!StartDate || !EndDate || !UserID || !AccessKey) {
      setLoading(false);
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Report/GetProfitOnSalesReport",
      headers: { "Content-Type": "application/json" },
      data: {
        UserID: UserID,
        AccessKey: AccessKey,
        StartDate: moment(StartDate).isValid()
          ? moment(StartDate).format("YYYY-MM-DD")
          : StartDate,
        EndDate: moment(EndDate).isValid()
          ? moment(EndDate).format("YYYY-MM-DD")
          : EndDate,
        ProductID: ProductID,
        SupplierID: SupplierID,
        ShowDetails: showDetails,
        PageNo: 1,
        PageSize: 20000,
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setData(response.data);
          setDetailRows(
            showDetails
              ? response.data.ListofProducts || []
              : response.data.ListofSaleProducts || []
          );
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }, [StartDate, EndDate, UserID, AccessKey, ProductID, SupplierID, showDetails]);

  const periodLabel = `${
    StartDate && moment(StartDate).isValid()
      ? moment(StartDate).format(config.date_format)
      : "—"
  } to ${
    EndDate && moment(EndDate).isValid()
      ? moment(EndDate).format(config.date_format)
      : "—"
  }`;

  const fmt = (val, decimals) =>
    PrintFormateNumber(parseReportAmount(val), decimals);

  const summaryData = useMemo(
    () => ({
      ...data,
      NetProfit:
        parseReportAmount(data.GrossProfit) -
        parseReportAmount(data.GrossExpenses),
    }),
    [data]
  );

  const renderDetailRows = () => {
    if (!detailRows.length) return null;

    if (showDetails) {
      return detailRows.map((item, index) => (
        <View key={index} style={saleReportStyles.row}>
          <View style={[saleReportStyles.td, { width: SUMMARY_COL.sr }]}>
            <Text style={saleReportStyles.tdValue}>{index + 1}</Text>
          </View>
          <View style={[saleReportStyles.td, { width: SUMMARY_COL.product }]}>
            <Text style={saleReportStyles.tdValue}>{item.Name || "-"}</Text>
          </View>
          <View
            style={[
              saleReportStyles.td,
              { width: SUMMARY_COL.qty, textAlign: "right" },
            ]}
          >
            <Text style={saleReportStyles.tdValue}>
              {fmt(item.Balance)}
            </Text>
          </View>
          <View
            style={[
              saleReportStyles.td,
              { width: SUMMARY_COL.salePrice, textAlign: "right" },
            ]}
          >
            <Text style={saleReportStyles.tdValue}>
              {fmt(item.Sale_Price)}
            </Text>
          </View>
          <View
            style={[
              saleReportStyles.td,
              { width: SUMMARY_COL.amount, textAlign: "right" },
            ]}
          >
            <Text style={saleReportStyles.tdValue}>
              {fmt(item.Amount, 0)}
            </Text>
          </View>
          <View
            style={[
              saleReportStyles.td,
              { width: SUMMARY_COL.buyPrice, textAlign: "right" },
            ]}
          >
            <Text style={saleReportStyles.tdValue}>
              {fmt(item.Last_Purchase_Price)}
            </Text>
          </View>
          <View
            style={[
              saleReportStyles.td,
              { width: SUMMARY_COL.profit, textAlign: "right" },
            ]}
          >
            <Text style={saleReportStyles.tdValue}>
              {fmt(item.Profit, 0)}
            </Text>
          </View>
        </View>
      ));
    }

    return detailRows.map((item, index) => (
      <View key={index} style={saleReportStyles.row}>
        <View style={[saleReportStyles.td, { width: DETAIL_COL.sr }]}>
          <Text style={saleReportStyles.tdValue}>{index + 1}</Text>
        </View>
        <View style={[saleReportStyles.td, { width: DETAIL_COL.dated }]}>
          <Text style={saleReportStyles.tdValue}>
            {item.Sale_Invoice_Head_BE?.Dated
              ? moment(item.Sale_Invoice_Head_BE.Dated).format(
                  config.date_format
                )
              : "-"}
          </Text>
        </View>
        <View style={[saleReportStyles.td, { width: DETAIL_COL.product }]}>
          <Text style={saleReportStyles.tdValue}>
            {item.Product_BE?.Name || item.Name || "-"}
          </Text>
        </View>
        <View
          style={[
            saleReportStyles.td,
            { width: DETAIL_COL.qty, textAlign: "right" },
          ]}
        >
          <Text style={saleReportStyles.tdValue}>{fmt(item.Quantity)}</Text>
        </View>
        <View
          style={[
            saleReportStyles.td,
            { width: DETAIL_COL.salePrice, textAlign: "right" },
          ]}
        >
          <Text style={saleReportStyles.tdValue}>{fmt(item.Price)}</Text>
        </View>
        <View
          style={[
            saleReportStyles.td,
            { width: DETAIL_COL.amount, textAlign: "right" },
          ]}
        >
          <Text style={saleReportStyles.tdValue}>{fmt(item.Amount, 0)}</Text>
        </View>
        <View
          style={[
            saleReportStyles.td,
            { width: DETAIL_COL.buyPrice, textAlign: "right" },
          ]}
        >
          <Text style={saleReportStyles.tdValue}>
            {fmt(item.Purchase_Price)}
          </Text>
        </View>
        <View
          style={[
            saleReportStyles.td,
            { width: DETAIL_COL.profit, textAlign: "right" },
          ]}
        >
          <Text style={saleReportStyles.tdValue}>{fmt(item.Profit, 0)}</Text>
        </View>
      </View>
    ));
  };

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={saleReportStyles.page}>
        <PrintHeaderAccount compact />
        <View style={saleReportStyles.section}>
          <View style={saleReportStyles.titleBlock}>
            <Text style={saleReportStyles.pagetitle}>Profit On Sales</Text>
            <Text style={saleReportStyles.reportSubtitle}>
              Period: {periodLabel}
            </Text>
            <Text style={saleReportStyles.reportSubtitle}>
              View: {showDetails ? "Product summary" : "Sale line detail"}
            </Text>
          </View>

          <View style={saleReportStyles.table}>
            <View style={saleReportStyles.tableHead}>
              {showDetails ? (
                <>
                  <View style={[saleReportStyles.th, { width: SUMMARY_COL.sr }]}>
                    <Text style={saleReportStyles.thValue}>Sr.</Text>
                  </View>
                  <View
                    style={[saleReportStyles.th, { width: SUMMARY_COL.product }]}
                  >
                    <Text style={saleReportStyles.thValue}>Product</Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: SUMMARY_COL.qty, textAlign: "right" },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Qty</Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: SUMMARY_COL.salePrice, textAlign: "right" },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Sale Price</Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: SUMMARY_COL.amount, textAlign: "right" },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Amount</Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: SUMMARY_COL.buyPrice, textAlign: "right" },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Buying Price</Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: SUMMARY_COL.profit, textAlign: "right" },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Profit</Text>
                  </View>
                </>
              ) : (
                <>
                  <View style={[saleReportStyles.th, { width: DETAIL_COL.sr }]}>
                    <Text style={saleReportStyles.thValue}>Sr.</Text>
                  </View>
                  <View
                    style={[saleReportStyles.th, { width: DETAIL_COL.dated }]}
                  >
                    <Text style={saleReportStyles.thValue}>Dated</Text>
                  </View>
                  <View
                    style={[saleReportStyles.th, { width: DETAIL_COL.product }]}
                  >
                    <Text style={saleReportStyles.thValue}>Product</Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: DETAIL_COL.qty, textAlign: "right" },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Qty</Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: DETAIL_COL.salePrice, textAlign: "right" },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Sale Price</Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: DETAIL_COL.amount, textAlign: "right" },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Amount</Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: DETAIL_COL.buyPrice, textAlign: "right" },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Buying Price</Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.th,
                      { width: DETAIL_COL.profit, textAlign: "right" },
                    ]}
                  >
                    <Text style={saleReportStyles.thValue}>Profit</Text>
                  </View>
                </>
              )}
            </View>

            {renderDetailRows()}
          </View>

          <View style={[saleReportStyles.title, { marginTop: 8 }]}>
            <Text style={saleReportStyles.pagetitle}>Profit and Loss Summary</Text>
          </View>

          <View style={saleReportStyles.table}>
            <View style={saleReportStyles.tableHead}>
              <View style={[saleReportStyles.th, { width: SUMMARY_LABEL }]}>
                <Text style={saleReportStyles.thValue}>Description</Text>
              </View>
              <View
                style={[
                  saleReportStyles.th,
                  { width: SUMMARY_VALUE, textAlign: "right" },
                ]}
              >
                <Text style={saleReportStyles.thValue}>Amount (Rs.)</Text>
              </View>
            </View>

            {SUMMARY_ROWS.map((row, index) => {
              if (row.separator) {
                return (
                  <View key={`sep-${index}`} style={saleReportStyles.row}>
                    <View
                      style={[saleReportStyles.td, { width: SUMMARY_LABEL }]}
                    >
                      <Text style={saleReportStyles.tdValue}></Text>
                    </View>
                    <View
                      style={[
                        saleReportStyles.td,
                        { width: SUMMARY_VALUE, textAlign: "right" },
                      ]}
                    >
                      <Text style={saleReportStyles.tdValue}>—</Text>
                    </View>
                  </View>
                );
              }

              const value =
                row.key === "NetProfit"
                  ? summaryData.NetProfit
                  : summaryData[row.key];

              return (
                <View key={row.key || index} style={saleReportStyles.row}>
                  <View
                    style={[saleReportStyles.td, { width: SUMMARY_LABEL }]}
                  >
                    <Text
                      style={
                        row.bold
                          ? saleReportStyles.thValue
                          : saleReportStyles.tdValue
                      }
                    >
                      {row.label}
                    </Text>
                  </View>
                  <View
                    style={[
                      saleReportStyles.td,
                      { width: SUMMARY_VALUE, textAlign: "right" },
                    ]}
                  >
                    <Text
                      style={
                        row.bold
                          ? saleReportStyles.thValue
                          : saleReportStyles.tdValue
                      }
                    >
                      {fmt(value, 0)}
                    </Text>
                  </View>
                </View>
              );
            })}
          </View>

          <View
            style={{ marginBottom: 20, marginTop: 0, top: 6, bottom: 6 }}
            fixed
          >
            <Text
              style={{ fontSize: "7pt", color: "#000" }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
  );

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {loading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <PDFViewer width="100%" height="100%" fileName="ProfitOnSales.pdf">
          <MyDocument />
        </PDFViewer>
      )}
    </div>
  );
}

export default PrintProfitOnSale;
